
(function() {
  'use strict';

  const CONFIG = {
    debounceDelay: 100,
    maxAltLength: 125,
    observerThrottle: 50
  };

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  function fixDuplicateAltText() {
    const images = document.querySelectorAll('img[alt]');
    const altTextMap = new Map();

    images.forEach(function(img, index) {
      const altText = img.getAttribute('alt').trim();
      const src = img.getAttribute('src') || img.getAttribute('data-src');

      if (altText && src) {
        if (altTextMap.has(altText)) {
          const existingImages = altTextMap.get(altText);
          const isDifferentImage = !existingImages.some(function(existingImg) {
            const existingSrc = existingImg.getAttribute('src') || existingImg.getAttribute('data-src');
            return existingSrc === src;
          });

          if (isDifferentImage) {
            if (img.closest('.ProductItem__Image--alternate')) {
              img.setAttribute('alt', altText + ' - alternate view');
            } else if (img.closest('.ProductItem')) {
              img.setAttribute('alt', altText + ' - product image ' + (existingImages.length + 1));
            } else {
              img.setAttribute('alt', altText + ' - image ' + (existingImages.length + 1));
            }
          }

          existingImages.push(img);
        } else {
          altTextMap.set(altText, [img]);
        }
      }
    });
  }

  function fixSearchSpringRecommendationAltText() {
    const searchspringImages = document.querySelectorAll('img[ng-if="recommendations"]');
    const altTextGroups = new Map();
    const processedImages = new Set();

    searchspringImages.forEach(function(img) {
      const altText = img.getAttribute('alt');
      if (!altText || altText.trim() === '') return;

      const cleanAltText = altText.trim();
      if (!altTextGroups.has(cleanAltText)) {
        altTextGroups.set(cleanAltText, []);
      }
      altTextGroups.get(cleanAltText).push(img);
    });

    altTextGroups.forEach(function(images, altText) {
      if (images.length <= 1) return; // Skip groups with only one image

      images.forEach(function(img, index) {
        if (processedImages.has(img)) return;
        processedImages.add(img);

        const src = img.getAttribute('src') || img.getAttribute('ng-src');
        
        if (index === 0) return;

        const isAlternateView = img.classList.contains('ProductItem__Image--alternate');
        
        let hasSameSource = false;
        for (let i = 0; i < index; i++) {
          const prevSrc = images[i].getAttribute('src') || images[i].getAttribute('ng-src');
          if (src === prevSrc) {
            hasSameSource = true;
            break;
          }
        }

        if (!hasSameSource) {
          let newAltText;
          
          if (isAlternateView) {
            newAltText = altText + ' - alternate view';
          } else {
            newAltText = altText + ' - style ' + (index + 1);
          }
          
          img.setAttribute('alt', newAltText);
          
          const originalAlt = img.getAttribute('data-uw-rm-alt-original');
          if (originalAlt) {
            img.setAttribute('data-uw-rm-alt-original', newAltText);
          }
          
          const uwRmAlt = img.getAttribute('data-uw-rm-alt');
          if (uwRmAlt === 'ALT') {
            img.setAttribute('data-uw-rm-alt-original', newAltText);
          }
          
          const titleAttr = img.getAttribute('title');
          if (titleAttr && titleAttr.trim() === altText) {
            img.setAttribute('title', newAltText);
          }
        }
      });
    });

    setTimeout(function() {
      const newSearchspringImages = document.querySelectorAll('img[ng-if="recommendations"]:not([data-alt-processed])');
      newSearchspringImages.forEach(function(img) {
        img.setAttribute('data-alt-processed', 'true');
      });
      
      if (newSearchspringImages.length > 0) {
        fixSearchSpringRecommendationAltText();
      }
    }, 1000);
  }

  function observeSearchSpringContent() {
    const searchSpringObserver = new MutationObserver(function(mutations) {
      let shouldRunFix = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const hasSearchSpringImages = node.matches && node.matches('img[ng-if="recommendations"]') ||
                                          node.querySelector && node.querySelector('img[ng-if="recommendations"]');
              
              if (hasSearchSpringImages) {
                shouldRunFix = true;
              }
            }
          });
        }
        
        if (mutation.type === 'attributes' && 
            mutation.target.matches && mutation.target.matches('img[ng-if="recommendations"]') &&
            (mutation.attributeName === 'src' || mutation.attributeName === 'alt')) {
          shouldRunFix = true;
        }
      });
      
      if (shouldRunFix) {
        clearTimeout(searchSpringObserver.timeout);
        searchSpringObserver.timeout = setTimeout(function() {
          fixSearchSpringRecommendationAltText();
        }, CONFIG.debounceDelay);
      }
    });

    searchSpringObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'alt', 'ng-src']
    });

    document.addEventListener('searchspring-recommendations-loaded', function() {
      setTimeout(fixSearchSpringRecommendationAltText, 100);
    });

    if (window.jQuery) {
      window.jQuery(document).ajaxComplete(function(event, xhr, settings) {
        if (settings.url && settings.url.includes('searchspring')) {
          setTimeout(fixSearchSpringRecommendationAltText, 500);
        }
      });
    }

    return searchSpringObserver;
  }

  function fixLongAltAttributes() {
    const images = document.querySelectorAll('img[alt]');

    images.forEach(function(img) {
      const altText = img.getAttribute('alt');
      if (altText && altText.length > CONFIG.maxAltLength) {
        let shortAlt = altText;

        if (altText.includes('woman') && altText.includes('wearing')) {
          const productMatch = altText.match(/wearing\s+(?:a\s+)?([^.]+?)(?:\s+stacked|\s+on)/i);
          if (productMatch) {
            shortAlt = 'Woman wearing ' + productMatch[1].trim();
          } else {
            shortAlt = 'Woman wearing jewelry';
          }
        } else if (altText.includes('DISCLAIMER') || altText.includes('Discount')) {
          shortAlt = 'Sale promotion image';
        } else if (altText === 'Image') {
          const productTitle = img.closest('.ProductItem')?.querySelector('.ProductItem__Title a')?.textContent;
          if (productTitle) {
            shortAlt = productTitle.trim();
          } else {
            shortAlt = 'Product image';
          }
        } else {
          shortAlt = altText.substring(0, 100).trim() + '...';
        }

        img.setAttribute('alt', shortAlt);
        img.setAttribute('data-original-alt', altText);
      }
    });
  }

   function fixInconsistentLinkText() {
     const links = document.querySelectorAll('a[href]');
     const linkMap = new Map();

     links.forEach(function(link) {
       const href = link.getAttribute('href');
       const text = link.textContent.trim();
       const ariaLabel = link.getAttribute('aria-label');

       if (href && (text || ariaLabel)) {
         let cleanAriaLabel = ariaLabel ? ariaLabel
           .replace(/ - product image \d+/gi, '')
           .replace(/ - alternate view/gi, '')
           .replace(/ - image \d+/gi, '')
           .replace(/<[^>]*>/g, '') // Remove HTML tags
           .replace(/&quot;/g, '"') // Decode HTML entities
           .replace(/&lt;/g, '<')
           .replace(/&gt;/g, '>')
           .replace(/&amp;/g, '&')
           .replace(/\s+/g, ' ') // Normalize whitespace
           .trim() : '';

         if (cleanAriaLabel && (cleanAriaLabel.includes('div role=') || cleanAriaLabel.includes('background-image:'))) {
           if (cleanAriaLabel.includes('SHOP ')) {
             const shopMatch = cleanAriaLabel.match(/SHOP\s+([A-Z\s]+)/i);
             if (shopMatch) {
               cleanAriaLabel = `Shop ${shopMatch[1].trim()}`;
             }
           } else if (cleanAriaLabel.includes('LEARN MORE')) {
             cleanAriaLabel = 'Learn More';
           } else {
             cleanAriaLabel = text || 'Link';
           }
         }

         if (linkMap.has(href)) {
           const existingLink = linkMap.get(href);
           let standardText = existingLink.cleanAriaLabel || existingLink.text;
           let currentText = cleanAriaLabel || text;

           if (currentText && currentText.length > 0 && currentText.length < standardText.length && !currentText.includes('div role=')) {
             standardText = currentText;
           } else if (currentText && currentText.length > standardText.length && !currentText.includes('div role=')) {
             standardText = currentText;
           }

           if (standardText && standardText !== text && !standardText.includes('div role=')) {
             link.setAttribute('aria-label', standardText);
           }
           if (standardText && standardText !== existingLink.text && standardText !== existingLink.cleanAriaLabel && !standardText.includes('div role=')) {
             existingLink.element.setAttribute('aria-label', standardText);
           }
         } else {
           linkMap.set(href, { text: text, ariaLabel: ariaLabel, cleanAriaLabel: cleanAriaLabel, element: link });
         }
       }
     });
   }

   function fixSearchSpringProductLinks() {
     const searchSpringLinks = document.querySelectorAll('a[ng-href][class*="ProductItem"], a[href*="/products/"][class*="ProductItem"]');
     const productLinkMap = new Map();

     searchSpringLinks.forEach(function(link) {
       const href = link.getAttribute('href') || link.getAttribute('ng-href');
       const ariaLabel = link.getAttribute('aria-label');
       const text = link.textContent.trim();

       if (href && href.includes('/products/')) {
         const productName = href.split('/products/')[1].split('?')[0].replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
         
         if (productLinkMap.has(href)) {
           const existingLink = productLinkMap.get(href);
           
           const standardAriaLabel = `Shop ${productName}`;
           
           link.setAttribute('aria-label', standardAriaLabel);
           existingLink.element.setAttribute('aria-label', standardAriaLabel);
         } else {
           productLinkMap.set(href, { 
             text: text, 
             ariaLabel: ariaLabel, 
             element: link,
             productName: productName
           });
         }
       }
     });
   }

  function fixAccessibleNameMismatch() {
    const links = document.querySelectorAll('a[aria-label]');

    links.forEach(function(link) {
      const ariaLabel = link.getAttribute('aria-label');
      const visibleText = link.textContent.trim();

      if (ariaLabel && ariaLabel.includes('<img')) {
        if (ariaLabel.includes('Latest Arrivals')) {
          link.setAttribute('aria-label', 'Shop Latest Arrivals');
        } else if (ariaLabel.includes('Heartstrings')) {
          link.setAttribute('aria-label', 'Shop Heartstrings Collection');
        } else if (ariaLabel.includes('Paracord')) {
          link.setAttribute('aria-label', 'Shop Paracord Collection');
        } else if (ariaLabel.includes('Tennis')) {
          link.setAttribute('aria-label', 'Shop Tennis Collection');
        } else if (ariaLabel.includes('Hinged Huggie')) {
          link.setAttribute('aria-label', 'Shop Hinged Huggie Collection');
        } else if (visibleText) {
          link.setAttribute('aria-label', visibleText);
        } else {
          link.removeAttribute('aria-label');
        }
      }

      if (ariaLabel && visibleText) {
        const ariaLowerCase = ariaLabel.toLowerCase();
        const visibleLowerCase = visibleText.toLowerCase();
        
        if (!ariaLowerCase.includes(visibleLowerCase) && !visibleLowerCase.includes(ariaLowerCase)) {
          if (ariaLabel.includes('ITTY BITTY HEARTSTRINGS')) {
            link.setAttribute('aria-label', 'Heartstrings Collection');
          } else if (ariaLabel.includes('NEW STONE AGE')) {
            link.setAttribute('aria-label', 'Latest Arrivals');
          } else if (ariaLabel.includes('New styles just dropped')) {
            link.setAttribute('aria-label', 'Latest Arrivals');
          } else if (visibleText.length > 0) {
            link.setAttribute('aria-label', visibleText);
          } else {
            const cleanLabel = ariaLabel
              .replace(/[A-Z]{2,}/g, function(match) {
                return match.charAt(0) + match.slice(1).toLowerCase();
              })
              .replace(/\s+/g, ' ')
              .trim();
            
            if (cleanLabel.length > 0 && cleanLabel.length < 100) {
              link.setAttribute('aria-label', cleanLabel);
            }
          }
        }
      }

      if (ariaLabel === 'Free shipping on all U.S. orders over $300! See more for details.' &&
          visibleText === 'Free shipping on all U.S. orders over $300! See more for details.') {
        link.removeAttribute('aria-label'); // Text matches, aria-label is redundant
      }
    });
  }

   function fixEmptyAltAttributes() {
     const images = document.querySelectorAll('img');

     images.forEach(function(img) {
       const altText = img.getAttribute('alt');
       const src = img.getAttribute('src') || img.getAttribute('data-src');

       if (!img.hasAttribute('alt')) {
         if (img.closest('.Icon, .PlaceholderBackground') ||
             img.classList.contains('icon') ||
             img.classList.contains('decorative') ||
             (src && (src.includes('placeholder') || src.includes('no-image')))) {
           img.setAttribute('alt', '');
           img.setAttribute('aria-hidden', 'true');
         } else {
           const productTitle = img.closest('.ProductItem')?.querySelector('.ProductItem__Title a')?.textContent;
           const collectionTitle = img.closest('.CollectionItem')?.querySelector('.SectionHeader__Heading')?.textContent;

           if (productTitle) {
             img.setAttribute('alt', productTitle.trim());
           } else if (collectionTitle) {
             img.setAttribute('alt', collectionTitle.trim());
           } else {
             img.setAttribute('alt', 'Product image');
           }
         }
       }
       else if (altText === '') {
         img.setAttribute('aria-hidden', 'true');
       }
       else if (altText === 'Image') {
         const productTitle = img.closest('.ProductItem')?.querySelector('.ProductItem__Title a')?.textContent;
         if (productTitle) {
           img.setAttribute('alt', productTitle.trim());
         } else {
           img.setAttribute('alt', 'Product image');
         }
       }
     });

     const areas = document.querySelectorAll('area:not([alt])');
     areas.forEach(function(area) {
       const title = area.getAttribute('title');
       const coords = area.getAttribute('coords');
       
       if (title && title.trim()) {
         area.setAttribute('alt', title.trim());
       } else if (coords) {
         area.setAttribute('alt', 'Interactive map area');
       } else {
         area.setAttribute('alt', 'Map region');
       }
     });
   }

  function fixDuplicateIds() {
    const elementsWithIds = document.querySelectorAll('[id]');
    const idMap = new Map();

    elementsWithIds.forEach(function(element) {
      const id = element.id;
      if (idMap.has(id)) {
        const counter = idMap.get(id) + 1;
        element.id = id + '_' + counter;
        idMap.set(id, counter);
      } else {
        idMap.set(id, 1);
      }
    });
  }

  function fixMismatchedAltTitle() {
    const images = document.querySelectorAll('img[alt][title]');

    images.forEach(function(img) {
      const altText = img.getAttribute('alt').trim();
      const titleText = img.getAttribute('title').trim();

      if (altText && titleText && altText !== titleText) {
        const cleanAlt = altText
          .replace(/ - product image \d+/gi, '')
          .replace(/ - alternate view/gi, '')
          .replace(/ - image \d+/gi, '')
          .trim();
          
        const cleanTitle = titleText
          .replace(/ - product image \d+/gi, '')
          .replace(/ - alternate view/gi, '')
          .replace(/ - image \d+/gi, '')
          .trim();

        const standardText = cleanTitle || cleanAlt;
        
        if (standardText) {
          img.setAttribute('alt', standardText);
          img.setAttribute('title', standardText);
        }
      }
    });
  }

   function fixAriaHiddenIssues() {
     const elementsWithAriaHidden = document.querySelectorAll('[aria-hidden="true"]');
     
     elementsWithAriaHidden.forEach(function(element) {
       const focusableChildren = element.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"]');
       
       if (focusableChildren.length > 0) {
         if (element.classList.contains('Drawer') || element.classList.contains('Search') || element.classList.contains('SidebarMenu') || element.classList.contains('Modal')) {
           return;
         }
         
         element.removeAttribute('aria-hidden');
         if (!element.hasAttribute('role')) {
           element.setAttribute('role', 'region');
         }
         if (!element.hasAttribute('aria-label') && !element.hasAttribute('aria-labelledby')) {
           element.setAttribute('aria-label', 'Interactive content');
         }
       }
     });
   }

   function fixAreaAltAttributes() {
     const areaElements = document.querySelectorAll('area:not([alt])');
     areaElements.forEach(function(area) {
       let altText = area.getAttribute('title') || area.getAttribute('href') || 'Interactive area';
       if (altText && altText !== '') {
         area.setAttribute('alt', altText);
       } else {
         area.setAttribute('alt', 'Interactive map area');
       }
     });
   }

   function fixInconsistentLinkText() {
     const linkGroups = {};
     
     const allLinks = document.querySelectorAll('a[href]');
     allLinks.forEach(function(link) {
       const href = link.getAttribute('href');
       if (href && href !== '#' && href !== 'javascript:void(0)') {
         if (!linkGroups[href]) {
           linkGroups[href] = [];
         }
         linkGroups[href].push(link);
       }
     });
     
     Object.keys(linkGroups).forEach(function(href) {
       const links = linkGroups[href];
       if (links.length > 1) {
         let bestText = '';
         let bestLink = null;
         
         links.forEach(function(link) {
           const text = link.textContent.trim();
           const ariaLabel = link.getAttribute('aria-label');
           const title = link.getAttribute('title');
           
           const displayText = ariaLabel || text || title || '';
           
           if (displayText.length > bestText.length && displayText !== '') {
             bestText = displayText;
             bestLink = link;
           }
         });
         
         if (bestText && bestLink) {
           links.forEach(function(link) {
             const currentText = link.textContent.trim();
             const currentAriaLabel = link.getAttribute('aria-label');
             
             if (currentText !== bestText && currentText.length < bestText.length) {
               link.textContent = bestText;
               
               if (currentAriaLabel === bestText) {
                 link.removeAttribute('aria-label');
               }
             }
           });
         }
       }
     });
   }

   function fixSearchSpringHeadingLevels() {
     const searchSpringHeadings = document.querySelectorAll('.ssw-product-variant-choose-option-text[role="heading"]');
     
     searchSpringHeadings.forEach(function(heading) {
       if (heading.getAttribute('aria-level') === '1') {
         heading.setAttribute('aria-level', '2');
         if (heading.tagName === 'H3') {
           heading.outerHTML = heading.outerHTML.replace('<h3', '<h2').replace('</h3>', '</h2>');
         }
       }
     });
     
     const hiddenHeadings = document.querySelectorAll('.ssw-product-variants-title[role="presentation"]');
     hiddenHeadings.forEach(function(heading) {
       heading.setAttribute('aria-hidden', 'true');
       heading.setAttribute('role', 'presentation');
     });
   }

   function fixHeadingHierarchy() {
     const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"]');
     let lastLevel = 0;
     
     headings.forEach(function(heading) {
       let currentLevel;
       
       if (heading.hasAttribute('aria-level')) {
         currentLevel = parseInt(heading.getAttribute('aria-level'));
       } else {
         currentLevel = parseInt(heading.tagName.charAt(1));
       }
       
       if (currentLevel > lastLevel + 1) {
         const newLevel = lastLevel + 1;
         
         if (heading.hasAttribute('aria-level')) {
           heading.setAttribute('aria-level', newLevel.toString());
         } else {
           const newTag = 'h' + newLevel;
           const newHeading = document.createElement(newTag);
           
           for (let i = 0; i < heading.attributes.length; i++) {
             const attr = heading.attributes[i];
             newHeading.setAttribute(attr.name, attr.value);
           }
           
           newHeading.innerHTML = heading.innerHTML;
           
           heading.parentNode.replaceChild(newHeading, heading);
         }
         
         currentLevel = newLevel;
       }
       
       lastLevel = currentLevel;
     });
   }

   function fixColorContrastIssues() {
     const managePreferencesElements = document.querySelectorAll('span:contains("Manage preferences"), [data-uw-rm-text="Manage preferences"]');
     
     managePreferencesElements.forEach(function(element) {
       element.style.color = '#000000';
       element.style.backgroundColor = '#ffffff';
       element.style.padding = '4px 8px';
       element.style.borderRadius = '4px';
       element.style.fontWeight = 'bold';
     });
     
     const allSpans = document.querySelectorAll('span');
     allSpans.forEach(function(span) {
       if (span.textContent.trim() === 'Manage preferences') {
         span.style.color = '#000000';
         span.style.backgroundColor = '#ffffff';
         span.style.padding = '4px 8px';
         span.style.borderRadius = '4px';
         span.style.fontWeight = 'bold';
       }
     });
   }

   function fixSemanticMarkup() {
     const boldTags = document.querySelectorAll('b');
     boldTags.forEach(function(b) {
       const strong = document.createElement('strong');
       strong.innerHTML = b.innerHTML;
       for (let i = 0; i < b.attributes.length; i++) {
         const attr = b.attributes[i];
         strong.setAttribute(attr.name, attr.value);
       }
       b.parentNode.replaceChild(strong, b);
     });

     const italicTags = document.querySelectorAll('i');
     italicTags.forEach(function(i) {
       if (i.classList.contains('icon') || i.classList.contains('fa') || i.classList.contains('material-icons')) {
         return;
       }
       
       const em = document.createElement('em');
       em.innerHTML = i.innerHTML;
       for (let j = 0; j < i.attributes.length; j++) {
         const attr = i.attributes[j];
         em.setAttribute(attr.name, attr.value);
       }
       i.parentNode.replaceChild(em, i);
     });
   }

   function fixTabindexIssues() {
     const elementsWithHighTabindex = document.querySelectorAll('[tabindex]');
     
     elementsWithHighTabindex.forEach(function(element) {
       const tabindexValue = parseInt(element.getAttribute('tabindex'));
       
       if (tabindexValue > 0) {
         element.setAttribute('tabindex', '0');
       }
     });
   }

   function fixFormAccessibility() {
     const inputs = document.querySelectorAll('input:not([type="hidden"]), select, textarea');
     
     inputs.forEach(function(input) {
       const id = input.id || input.name;
       const existingLabel = document.querySelector(`label[for="${id}"]`);
       
       if (!existingLabel && !input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) {
         const placeholder = input.getAttribute('placeholder');
         const parentText = input.parentElement?.textContent?.trim();
         
         if (placeholder) {
           input.setAttribute('aria-label', placeholder);
         } else if (parentText && parentText.length < 50) {
           input.setAttribute('aria-label', parentText);
         } else {
           const type = input.type || input.tagName.toLowerCase();
           const labelMap = {
             'email': 'Email address',
             'password': 'Password',
             'search': 'Search',
             'tel': 'Phone number',
             'url': 'Website URL',
             'text': 'Text input',
             'select': 'Select option',
             'textarea': 'Text area'
           };
           input.setAttribute('aria-label', labelMap[type] || 'Input field');
         }
       }
     });

     const requiredInputs = document.querySelectorAll('input[required], select[required], textarea[required]');
     requiredInputs.forEach(function(input) {
       if (!input.getAttribute('aria-required')) {
         input.setAttribute('aria-required', 'true');
       }
     });

     const forms = document.querySelectorAll('form');
     forms.forEach(function(form) {
       form.addEventListener('submit', function(e) {
         const invalidInputs = form.querySelectorAll(':invalid');
         invalidInputs.forEach(function(input) {
           if (!input.getAttribute('aria-describedby')) {
             const errorId = input.id + '-error';
             input.setAttribute('aria-describedby', errorId);
             
             if (!document.getElementById(errorId)) {
               const errorMsg = document.createElement('div');
               errorMsg.id = errorId;
               errorMsg.className = 'error-message';
               errorMsg.setAttribute('role', 'alert');
               errorMsg.textContent = 'Please fill out this field correctly.';
               input.parentElement.appendChild(errorMsg);
             }
           }
         });
       });
     });
   }

  function enhanceKeyboardNavigation() {
    if (!document.querySelector('.skip-link, [href="#main-content"]')) {
      const skipLink = document.createElement('a');
      skipLink.href = '#main-content';
      skipLink.className = 'skip-link';
      skipLink.textContent = 'Skip to main content';
      skipLink.style.cssText = `
        position: absolute;
        top: -40px;
        left: 6px;
        background: #000;
        color: #fff;
        padding: 8px;
        text-decoration: none;
        z-index: 10000;
        border-radius: 4px;
      `;
      
      skipLink.addEventListener('focus', function() {
        this.style.top = '6px';
      });
      skipLink.addEventListener('blur', function() {
        this.style.top = '-40px';
      });
      
      document.body.insertBefore(skipLink, document.body.firstChild);
    }

    if (!document.querySelector('main, [role="main"], #main-content')) {
      const mainContent = document.querySelector('.main, .content, .container');
      if (mainContent) {
        mainContent.setAttribute('role', 'main');
        mainContent.id = 'main-content';
      }
    }

    const focusableElements = document.querySelectorAll(
      'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"], [role="link"]'
    );
    
    focusableElements.forEach(function(element) {
      element.addEventListener('focus', function() {
        if (!this.style.outline && !this.style.boxShadow) {
          this.style.outline = '2px solid #005fcc';
          this.style.outlineOffset = '2px';
        }
      });
    });

    const modals = document.querySelectorAll('[role="dialog"], .modal, .drawer');
    modals.forEach(function(modal) {
      modal.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') {
          const focusableElements = modal.querySelectorAll(
            'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];

          if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          } else if (!e.shiftKey && document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      });
    });
  }

  function addNewTabWarnings() {
    const externalLinks = document.querySelectorAll('a[target="_blank"]');

    externalLinks.forEach(function(link) {
      const ariaLabel = link.getAttribute('aria-label') || '';
      const linkText = link.textContent.trim();

      if (!ariaLabel.includes('new tab') && !ariaLabel.includes('new window') &&
          !linkText.includes('new tab') && !linkText.includes('new window')) {

        if (ariaLabel) {
          link.setAttribute('aria-label', ariaLabel + ' - opens in a new tab');
        } else if (linkText) {
          link.setAttribute('aria-label', linkText + ' - opens in a new tab');
        }
      }
    });
  }

  function addLandmarkRoles() {
    const navElements = document.querySelectorAll('nav:not([role]), .navigation:not([role]), .menu:not([role])');
    navElements.forEach(function(nav) {
      if (!nav.getAttribute('role')) {
        nav.setAttribute('role', 'navigation');
      }
      if (!nav.getAttribute('aria-label') && !nav.getAttribute('aria-labelledby')) {
        const navText = nav.querySelector('.menu-title, .nav-title')?.textContent || 'Navigation menu';
        nav.setAttribute('aria-label', navText);
      }
    });

    const headers = document.querySelectorAll('header:not([role]), .header:not([role])');
    headers.forEach(function(header) {
      header.setAttribute('role', 'banner');
    });

    const footers = document.querySelectorAll('footer:not([role]), .footer:not([role])');
    footers.forEach(function(footer) {
      footer.setAttribute('role', 'contentinfo');
    });

    const sidebars = document.querySelectorAll('.sidebar:not([role]), .aside:not([role]), aside:not([role])');
    sidebars.forEach(function(sidebar) {
      sidebar.setAttribute('role', 'complementary');
    });

    const searchForms = document.querySelectorAll('form[role="search"], .search-form:not([role])');
    searchForms.forEach(function(form) {
      form.setAttribute('role', 'search');
    });
  }

  function optimizeScreenReaderExperience() {
    const buttons = document.querySelectorAll('button:not([aria-label]):not([aria-labelledby])');
    buttons.forEach(function(button) {
      const buttonText = button.textContent.trim();
      const icon = button.querySelector('svg, .icon, i[class*="icon"]');
      
      if (!buttonText && icon) {
        const context = button.closest('.product-item, .cart, .search, .menu');
        if (context) {
          if (button.classList.contains('close') || button.querySelector('.close')) {
            button.setAttribute('aria-label', 'Close');
          } else if (button.classList.contains('add-to-cart') || button.querySelector('.cart')) {
            button.setAttribute('aria-label', 'Add to cart');
          } else if (button.classList.contains('search') || button.querySelector('.search')) {
            button.setAttribute('aria-label', 'Search');
          } else {
            button.setAttribute('aria-label', 'Button');
          }
        }
      }
    });

    const cartCount = document.querySelector('.cart-count, .cart-counter');
    if (cartCount && !cartCount.getAttribute('aria-live')) {
      cartCount.setAttribute('aria-live', 'polite');
      cartCount.setAttribute('aria-label', 'Cart items count');
    }

    const forms = document.querySelectorAll('form');
    forms.forEach(function(form) {
      if (!form.querySelector('[role="status"], [aria-live]')) {
        const statusDiv = document.createElement('div');
        statusDiv.setAttribute('role', 'status');
        statusDiv.setAttribute('aria-live', 'polite');
        statusDiv.className = 'sr-only';
        statusDiv.style.cssText = `
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        `;
        form.appendChild(statusDiv);
      }
    });

    const tables = document.querySelectorAll('table:not([role])');
    tables.forEach(function(table) {
      table.setAttribute('role', 'table');
      
      const caption = table.querySelector('caption');
      if (!caption) {
        const tableCaption = document.createElement('caption');
        tableCaption.textContent = 'Data table';
        tableCaption.className = 'sr-only';
        table.insertBefore(tableCaption, table.firstChild);
      }
    });
  }

  function manageModalAriaStates() {
    let currentOpenModal = null;

    function handleDrawerStateChange(drawer, isOpen) {
      if (isOpen) {
        drawer.setAttribute('aria-hidden', 'false');
        drawer.previouslyFocusedElement = document.activeElement;
        const firstFocusable = drawer.querySelector('button:not([tabindex="-1"]), input:not([tabindex="-1"]), select:not([tabindex="-1"]), textarea:not([tabindex="-1"])');
        if (firstFocusable) {
          setTimeout(() => firstFocusable.focus(), 100);
        }
        currentOpenModal = drawer;
      } else {
        drawer.setAttribute('aria-hidden', 'true');
        if (drawer.previouslyFocusedElement) {
          drawer.previouslyFocusedElement.focus();
          drawer.previouslyFocusedElement = null;
        }
        if (currentOpenModal === drawer) {
          currentOpenModal = null;
        }
      }
    }

    const classObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const element = mutation.target;
          
          if (element.classList.contains('Drawer') || element.classList.contains('Search') || element.classList.contains('SidebarMenu') || element.classList.contains('CollectionFilters')) {
            const isOpen = element.classList.contains('is-visible') || 
                           element.classList.contains('is-open') ||
                           element.style.transform === 'translateX(0px)' ||
                           element.style.transform === 'translateX(0%)' ||
                           element.offsetWidth > 0 && element.offsetHeight > 0 && 
                           window.getComputedStyle(element).visibility !== 'hidden';
            
            handleDrawerStateChange(element, isOpen);
          }
        }
      });
    });

     const modals = document.querySelectorAll('.Drawer, .Search, .SidebarMenu, .MegaMenu, .Popover, .CollectionFilters');
     modals.forEach(function(modal) {
       classObserver.observe(modal, {
         attributes: true,
         attributeFilter: ['class', 'style']
       });
       
       const isInitiallyVisible = modal.offsetWidth > 0 && modal.offsetHeight > 0 && 
                                 window.getComputedStyle(modal).visibility !== 'hidden';
       
       if (!isInitiallyVisible) {
         modal.setAttribute('aria-hidden', 'true');
       }
       
       if (modal.classList.contains('Search')) {
         const searchTriggers = document.querySelectorAll('[data-action="open-search"], .Search__Trigger');
         searchTriggers.forEach(function(trigger) {
           trigger.addEventListener('click', function() {
             modal.setAttribute('aria-hidden', 'false');
             const searchInput = modal.querySelector('input[type="search"], input[type="text"]');
             if (searchInput) {
               setTimeout(() => searchInput.focus(), 100);
             }
           });
         });
         
         const closeButtons = modal.querySelectorAll('[data-action="close-search"], .Search__Close');
         closeButtons.forEach(function(closeBtn) {
           closeBtn.addEventListener('click', function() {
             modal.setAttribute('aria-hidden', 'true');
           });
         });
       }
       
       if (modal.id === 'sidebar-cart') {
         const cartTriggers = document.querySelectorAll('[data-action="open-drawer"][data-drawer-id="sidebar-cart"], .Cart__Trigger');
         cartTriggers.forEach(function(trigger) {
           trigger.addEventListener('click', function() {
             modal.setAttribute('aria-hidden', 'false');
             const firstFocusable = modal.querySelector('button:not([tabindex="-1"]), input:not([tabindex="-1"]), select:not([tabindex="-1"]), textarea:not([tabindex="-1"]), [tabindex="0"]');
             if (firstFocusable) {
               setTimeout(() => firstFocusable.focus(), 100);
             }
           });
         });
         
         const closeButtons = modal.querySelectorAll('[data-action="close-drawer"][data-drawer-id="sidebar-cart"], .Drawer__Close');
         closeButtons.forEach(function(closeBtn) {
           closeBtn.addEventListener('click', function() {
             modal.setAttribute('aria-hidden', 'true');
           });
         });
       }
       
       if (modal.classList.contains('pswp')) {
         const observer = new MutationObserver(function(mutations) {
           mutations.forEach(function(mutation) {
             if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
               const isOpen = modal.classList.contains('pswp--open');
               modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
             }
           });
         });
         
         observer.observe(modal, {
           attributes: true,
           attributeFilter: ['class']
         });
       }
     });

    const popoverButtons = document.querySelectorAll('[aria-haspopup="dialog"], [aria-haspopup="true"]');
    popoverButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const popoverId = button.getAttribute('aria-controls');
        const popover = document.getElementById(popoverId);
        
        if (popover) {
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          const newExpanded = !isExpanded;
          
          button.setAttribute('aria-expanded', newExpanded);
          
          popover.setAttribute('aria-hidden', newExpanded ? 'false' : 'true');
          
          if (newExpanded) {
            const firstFocusable = popover.querySelector('button:not([tabindex="-1"]), input:not([tabindex="-1"]), select:not([tabindex="-1"]), textarea:not([tabindex="-1"]), [tabindex="0"]');
            if (firstFocusable) {
              setTimeout(() => firstFocusable.focus(), 100);
            }
            currentOpenModal = popover;
          } else {
            button.focus();
            if (currentOpenModal === popover) {
              currentOpenModal = null;
            }
          }
        }
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && currentOpenModal) {
        const closeButton = currentOpenModal.querySelector('[data-action="close-drawer"], [data-action="close-search"], .Drawer__Close');
        if (closeButton) {
          closeButton.click();
        } else {
          handleDrawerStateChange(currentOpenModal, false);
        }
      }
    });
  }

  function fixAdditionalAuditIssues() {
    if (!document.documentElement.getAttribute('lang')) {
      document.documentElement.setAttribute('lang', 'en');
    }

    const decorativeImages = document.querySelectorAll('img[alt=""], img[alt=" "], img:not([alt])');
    decorativeImages.forEach(function(img) {
      if (!img.getAttribute('role') && !img.getAttribute('aria-hidden')) {
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('role', 'presentation');
      }
    });

    const newWindowLinks = document.querySelectorAll('a[target="_blank"]:not([aria-label*="new tab"]):not([aria-label*="new window"])');
    newWindowLinks.forEach(function(link) {
      const currentLabel = link.getAttribute('aria-label') || link.textContent.trim();
      if (currentLabel && !currentLabel.includes('new tab') && !currentLabel.includes('new window')) {
        link.setAttribute('aria-label', currentLabel + ' (opens in new tab)');
      }
    });

    const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
    headings.forEach(function(heading) {
      if (!heading.textContent.trim() && !heading.getAttribute('aria-label')) {
        heading.style.display = 'none';
        heading.setAttribute('aria-hidden', 'true');
      }
    });

    const listItems = document.querySelectorAll('li');
    listItems.forEach(function(li) {
      if (!li.closest('ul, ol, menu')) {
        const wrapper = document.createElement('ul');
        wrapper.setAttribute('role', 'list');
        li.parentNode.insertBefore(wrapper, li);
        wrapper.appendChild(li);
      }
    });

    const iframes = document.querySelectorAll('iframe:not([title])');
    iframes.forEach(function(iframe) {
      const src = iframe.getAttribute('src') || '';
      if (src.includes('youtube') || src.includes('vimeo')) {
        iframe.setAttribute('title', 'Video player');
      } else if (src.includes('maps') || src.includes('google')) {
        iframe.setAttribute('title', 'Interactive map');
      } else {
        iframe.setAttribute('title', 'Embedded content');
      }
    });

    const unlabeledInputs = document.querySelectorAll('input:not([type="hidden"]):not([aria-label]):not([aria-labelledby])');
    unlabeledInputs.forEach(function(input) {
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (!label && input.placeholder) {
        input.setAttribute('aria-label', input.placeholder);
      }
    });

    const clickableDivs = document.querySelectorAll('div[onclick], div[data-action], div[data-toggle]');
    clickableDivs.forEach(function(div) {
      if (!div.getAttribute('role')) {
        div.setAttribute('role', 'button');
        div.setAttribute('tabindex', '0');
        
        div.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
          }
        });
      }
    });

    const interactiveElements = document.querySelectorAll('[onclick]:not([aria-label]):not([aria-labelledby]), [data-action]:not([aria-label]):not([aria-labelledby])');
    interactiveElements.forEach(function(element) {
      const text = element.textContent.trim();
      if (text) {
        element.setAttribute('aria-label', text);
      } else {
        element.setAttribute('aria-label', 'Interactive element');
      }
    });
  }

  function init() {
    const runFixes = function() {
      try {
        fixLongAltAttributes();
        fixDuplicateAltText();
         fixSearchSpringRecommendationAltText();
         fixSearchSpringHeadingLevels();
        //  fixHeadingHierarchy();
         fixSearchSpringProductLinks();
         fixColorContrastIssues();
         fixSemanticMarkup();
         fixTabindexIssues();
         fixFormAccessibility();
         enhanceKeyboardNavigation();
         addLandmarkRoles();
         optimizeScreenReaderExperience();
         fixInconsistentLinkText();
         fixAccessibleNameMismatch();
         fixEmptyAltAttributes();
         if (!window?.location?.href?.includes('stockists')) {
           fixDuplicateIds();
         }
         fixMismatchedAltTitle();
         fixAriaHiddenIssues();
         fixAreaAltAttributes();
         addNewTabWarnings();
         fixAdditionalAuditIssues();
         manageModalAriaStates();
      } catch (error) {
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runFixes);
    } else {
      runFixes();
    }

    const observer = new MutationObserver(debounce(runFixes, CONFIG.debounceDelay));
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    observeSearchSpringContent();
  }
  init();

})();
